import {
  TextInputProps as MantineTextInputProps,
  TextInput as MantineTextInput,
} from '@mantine/core';

export type TextInputProps = MantineTextInputProps;

export const TextInput = MantineTextInput;

TextInput.displayName = 'TextInput';
